import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { H2 } from '@r1-frontend/ui-react/components/typography/heading';
import { BlockContainer, FullWidthListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Join = styled(BlockContainer)`
    overflow: hidden;
    margin-top: 96px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        margin-top: 24px;
        padding: 16px;
    }
    
    @media (max-width: ${wideBreakpoints.tablet}) {
        margin-top: auto;
    }
`;

export const ImageWrapper = styled.div`
    position: absolute;
    right: 0;
    top: 0;
    height: 336px; 
    order: 1;

    img, picture {
        display: block;
        height: 100%;
        width: auto;
    }

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        right: -160px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        position: static;
        width: calc(100% + 32px);
        height: auto;
        order: 0;
        margin: -16px -16px 16px;

        img, picture {
            width: 100%;
            height: auto;
        }
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        height: 172px;

        img, picture {
            width: auto;
            height: 100%;
        }
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        overflow: hidden;
        position: relative;
        left: 0;

        img, picture {
            position: absolute;
            min-width: 398px;
        }
    }
`;

export const Title = styled(H2)`
    width: 400px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        width: 100%;
        ${FONTS.H3};
        text-align: center;
    }
    
    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.H4};
    }
`;

export const SFullWidthListContainer = styled(FullWidthListContainer)`
    @media (max-width: ${wideBreakpoints.laptop}) {
        gap: 0;
        align-items: center;
    }
`;

export const Link = styled.a`
    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
    }
`;
